(function () {
  'use strict';
  if (window.icReviewLayoutLoaded) return;
  window.icReviewLayoutLoaded = true;
  var copyNode = document.getElementById('ic-review-copy');
  if (!copyNode) return;
  var copy;
  try { copy = JSON.parse(copyNode.textContent); } catch (error) { return; }
  var css = `
    :host {display:block;max-width:1200px;margin:24px auto;scroll-margin-top:120px}
    #opinew-app-container {font-size:16px}

    .opw-overflow-hidden:has(> .opw-review-content) {border:1px solid #dbe2e8!important;border-radius:8px!important;box-shadow:none!important;background:#fff}
    .opw-review-content {padding:20px!important;gap:10px!important}
    .opw-review-content .opinew-review-text-container {font-size:16px!important;line-height:1.65!important;padding-top:2px!important}
    .opw-review-content p {font-size:16px!important;line-height:1.65!important}
    .opw-review-content .opw-new-card-thumbs {justify-content:flex-start!important;gap:10px!important;margin-top:4px}
    .opw-review-content .opw-new-card-thumbs img {width:88px!important;height:88px!important;object-fit:cover;border-radius:5px!important}
    .opw-review-content .show-more {display:inline-block;color:#183e7b!important;font-weight:600}
    .opw-review-content .show-more:focus-visible,.opw-new-card-thumbs a:focus-visible {outline:3px solid #3978bb;outline-offset:3px}
    @media(max-width:749px){.opw-review-content{padding:16px!important}.opw-review-content .opw-new-card-thumbs img{width:76px!important;height:76px!important}}

    .opw-main-content-container:has(.opw-bethefirst-text) > .summary-card-container {display:none!important}
    .opw-bethefirst-text.ic-review-empty {margin:0!important;padding:24px 28px!important;border:1px solid #dbe2e8!important;border-left:4px solid #183e7b!important;border-radius:8px!important;box-shadow:none!important;background:#f5f7fa;text-align:left!important}
    .ic-review-empty > div,.ic-review-empty > div > .opw-font3Xl {display:contents!important}
    .ic-review-empty > div > img {display:none!important}
    .ic-review-empty .ic-review-empty-row {display:grid!important;grid-template-columns:minmax(0,1fr) auto;gap:24px;align-items:center}
    .ic-review-empty .ic-review-original-title {display:none!important}
    .ic-review-empty .ic-review-copy {font-weight:400;max-width:820px;min-width:0;text-align:left!important}
    .ic-review-empty h2 {font-family:inherit;font-size:22px!important;line-height:1.3!important;font-weight:700;color:#173653;margin:0 0 8px!important}
    .ic-review-empty p {font-size:16px!important;line-height:1.6!important;color:#465461;margin:0!important}
    .ic-review-empty .ic-review-action {margin:0!important;padding:0!important}
    .ic-review-empty button {min-height:48px;font-size:16px!important;padding:14px 24px!important;border-radius:5px!important;background:#183e7b!important;color:white!important;border-color:#183e7b!important;white-space:nowrap}
    .ic-review-empty button:hover {background:#102f61!important}
    .ic-review-empty button:focus-visible {outline:3px solid #3978bb;outline-offset:4px}
    @media(max-width:749px){:host{margin:18px auto}.opw-bethefirst-text.ic-review-empty{padding:20px!important}.ic-review-empty .ic-review-empty-row{grid-template-columns:1fr;gap:18px}.ic-review-empty h2{font-size:20px}.ic-review-empty .ic-review-action{justify-content:flex-start!important}.ic-review-empty button{width:100%}}
  `;

  var modalStyle = document.createElement('style');
  modalStyle.textContent = `
    .opw-generic-modal.opw-review-modal-wrapper{position:fixed!important;inset:0!important;z-index:2147483647!important;display:flex!important;align-items:center!important;justify-content:center!important;padding:20px!important;background:rgba(17,30,48,.62)!important;backdrop-filter:blur(3px);box-sizing:border-box!important}
    .opw-review-modal-wrapper .opw-review-form-container{position:relative!important;top:auto!important;right:auto!important;bottom:auto!important;left:auto!important;transform:none!important;display:flex!important;flex-direction:column!important;width:100%!important;max-width:680px!important;height:auto!important;min-height:0!important;max-height:calc(100dvh - 40px)!important;margin:0!important;border-radius:12px!important;background:#fff!important;box-shadow:0 20px 70px #07182766!important;overflow:hidden!important;color:#283849!important;font-family:inherit!important}
    .opw-review-modal-wrapper .ic-review-modal-header{flex-shrink:0;padding:20px 124px 14px 24px;border-bottom:1px solid #e3e8ef;background:#fff}
    .opw-review-modal-wrapper .ic-review-modal-header h2{font:700 23px/1.3 inherit;font-family:inherit;font-size:23px;font-weight:700;line-height:1.3;margin:0 0 6px;color:#183e7b}
    .opw-review-modal-wrapper .ic-review-modal-header p{font-size:15px;line-height:1.5;margin:0;color:#526170}
    .opw-review-modal-wrapper .opw-review-modal-content{flex:1 1 auto!important;min-height:0!important;height:auto!important;max-height:calc(100dvh - 210px)!important;overflow-y:auto!important;padding:22px 26px!important;overscroll-behavior:contain}
    .opw-review-modal-wrapper .close-icon{position:absolute!important;z-index:10!important;top:14px!important;right:16px!important;display:inline-flex!important;align-items:center;justify-content:center;gap:7px;min-width:90px;min-height:44px;padding:8px 12px!important;background:#f0f3f7!important;border:1px solid #ccd5df!important;border-radius:6px!important;color:#243b53!important;font-size:16px!important;line-height:1.2!important;text-decoration:none!important;font-weight:600!important}
    .opw-review-modal-wrapper .close-icon i{display:none!important}
    .opw-review-modal-wrapper .ic-review-modal-footer{flex-shrink:0;display:flex;justify-content:flex-end;padding:12px 24px;border-top:1px solid #e3e8ef;background:#f7f9fb}
    .opw-review-modal-wrapper .ic-review-modal-cancel{min-height:44px;padding:10px 18px;border:1px solid #b8c5d3;border-radius:6px;background:#fff;color:#243b53;font-family:inherit;font-size:16px;cursor:pointer}
    .opw-review-modal-wrapper .opw-requestBtnColor,.opw-review-modal-wrapper .opw-writeReviewButtonColor{background:#183e7b!important;color:#fff!important;border-radius:6px!important;min-height:46px!important;font-size:16px!important}
    .opw-review-modal-wrapper .opw-requestProgressBarColor{background:#183e7b!important}
    .opw-review-modal-wrapper button:disabled{opacity:.5!important;cursor:not-allowed!important}
    .opw-review-modal-wrapper :is(button,a,input,textarea):focus-visible{outline:3px solid #3978bb!important;outline-offset:3px}
    @media(max-width:749px){.opw-generic-modal.opw-review-modal-wrapper{padding:12px!important}.opw-review-modal-wrapper .opw-review-form-container{max-height:calc(100dvh - 24px)!important}.opw-review-modal-wrapper .ic-review-modal-header{padding:18px 108px 14px 18px}.opw-review-modal-wrapper .ic-review-modal-header h2{font-size:20px}.opw-review-modal-wrapper .ic-review-modal-header p{font-size:14px}.opw-review-modal-wrapper .opw-review-modal-content{padding:20px 18px!important;max-height:calc(100dvh - 220px)!important}.opw-review-modal-wrapper .close-icon{right:10px!important;top:12px!important;min-width:84px}.opw-review-modal-wrapper .ic-review-modal-footer{padding:10px 18px}}
  `;
  document.head.appendChild(modalStyle);
  var activeModal = null;
  var returnFocus = null;
  var previousOverflow = '';
  function modalFocusables(modal) {
    return Array.from(modal.querySelectorAll('a[href],button,input,textarea,select,[tabindex]')).filter(function (el) {
      return !el.disabled && el.tabIndex >= 0 && el.getClientRects().length;
    });
  }
  function enhanceModal() {
    var modal = document.querySelector('.opw-review-modal-wrapper');
    if (!modal || !modal.getClientRects().length) {
      if (activeModal) {
        document.body.style.overflow = previousOverflow;
        if (returnFocus && returnFocus.isConnected) returnFocus.focus({preventScroll:true});
        activeModal = null;
      }
      return;
    }
    var card = modal.querySelector('.opw-review-form-container');
    var close = modal.querySelector('a.close-icon');
    if (!card || !close) return;
    if (!activeModal) {
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      activeModal = modal;
    }
    card.setAttribute('role','dialog');
    card.setAttribute('aria-modal','true');
    card.setAttribute('aria-labelledby','ic-review-modal-title');
    if (!card.querySelector('.ic-review-modal-header')) {
      var header = document.createElement('header');
      header.className = 'ic-review-modal-header';
      var title = document.createElement('h2');
      title.id = 'ic-review-modal-title';
      title.textContent = copy.modal_title;
      var hint = document.createElement('p');
      hint.textContent = copy.modal_hint;
      header.append(title,hint);
      card.prepend(header);
      var footer = document.createElement('footer');
      footer.className = 'ic-review-modal-footer';
      var cancel = document.createElement('button');
      cancel.type = 'button';
      cancel.className = 'ic-review-modal-cancel';
      cancel.textContent = copy.cancel;
      cancel.addEventListener('click',function(){close.click();});
      footer.appendChild(cancel);
      card.appendChild(footer);
      var label = document.createElement('span');
      label.className = 'ic-review-close-label';
      label.textContent = '× ' + copy.close;
      close.appendChild(label);
      close.setAttribute('aria-label',copy.close);
      close.setAttribute('role','button');
      close.focus({preventScroll:true});
    }
  }
  document.addEventListener('click',function(event){
    var path = event.composedPath();
    var trigger = path.find(function(el){return el && el.tagName === 'BUTTON' && /write\s*(a\s*)?review/i.test(el.textContent);});
    if (trigger) returnFocus = trigger;
  },true);
  document.addEventListener('keydown',function(event){
    if (!activeModal) return;
    if (event.key === 'Escape') {
      event.preventDefault();
      activeModal.querySelector('a.close-icon').click();
    } else if (event.key === 'Tab') {
      var items = modalFocusables(activeModal);
      var first = items[0], last = items[items.length-1];
      if (!first) return;
      if (event.shiftKey && document.activeElement === first) {event.preventDefault();last.focus();}
      else if (!event.shiftKey && document.activeElement === last) {event.preventDefault();first.focus();}
    }
  });
  var modalQueued = false;
  var modalObserver = new MutationObserver(function(){
    if (modalQueued) return;
    modalQueued = true;
    requestAnimationFrame(function(){modalQueued=false;enhanceModal();});
  });
  modalObserver.observe(document.body,{childList:true,subtree:true});
  enhanceModal();

  var roots = new WeakSet();
  function enhance(root) {
    var empty = root.querySelector('.opw-bethefirst-text');
    if (!empty || empty.querySelector('.ic-review-copy')) return;
    var button = empty.querySelector('button');
    if (!button) return;
    var action = button.parentElement;
    var row = action.parentElement;
    var title = row.firstElementChild;
    if (!title || title === action) return;
    empty.classList.add('ic-review-empty');
    row.classList.add('ic-review-empty-row');
    title.classList.add('ic-review-original-title');
    action.classList.add('ic-review-action');
    var text = document.createElement('div');
    text.className = 'ic-review-copy';
    var heading = document.createElement('h2');
    heading.textContent = copy.title;
    var body = document.createElement('p');
    body.textContent = copy.body;
    text.append(heading, body);
    row.insertBefore(text, title);
    var label = button.querySelector('span');
    (label || button).textContent = copy.button;
  }
  function connect(host) {
    var root = host.shadowRoot;
    if (!root || roots.has(root)) return;
    roots.add(root);
    var style = document.createElement('style');
    style.setAttribute('data-ic-review-layout', '');
    style.textContent = css;
    root.appendChild(style);
    var observer = new MutationObserver(function () { enhance(root); });
    observer.observe(root, {childList:true, subtree:true});
    enhance(root);
  }
  function scan() { document.querySelectorAll('opinew-plugin[type="product"]').forEach(connect); }
  if (window.customElements) window.customElements.whenDefined('opinew-plugin').then(scan);
  document.addEventListener('OpinewWidgetLoaded', scan);
  document.addEventListener('shopify:section:load', scan);
  scan();
})();
